// @ts-ignore
import { isValidNumber } from 'libphonenumber-js';
var FormValidator = /** @class */ (function () {
    function FormValidator() {
    }
    //  basic for now
    FormValidator.prototype.fieldsNotEmpty = function (obj, props) {
        for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
            var prop = props_1[_i];
            if (typeof obj[prop] === "string") {
                if (obj[prop].length === 0) {
                    return false;
                }
            }
            else if (typeof obj[prop] === undefined || obj[prop] === null) {
                return false;
            }
        }
        return true;
    };
    FormValidator.prototype.validatePhone = function (phone) {
        var valid = isValidNumber(phone, 'US');
        return valid;
    };
    FormValidator.prototype.validateEmail = function (email) {
        var rgxTest = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
        if (!email)
            return false;
        if (email.length > 254)
            return false;
        if (!rgxTest.test(email))
            return false;
        var parts = email.split("@");
        if (parts[0].length > 64)
            return false;
        var domainParts = parts[1].split(".");
        if (domainParts.some(function (part) { return part.length > 63; })) {
            return false;
        }
        return true;
    };
    return FormValidator;
}());
export default new FormValidator();



//////////////////
// WEBPACK FOOTER
// ./src/utils/FormValidator.ts
// module id = dDRF
// module chunks = 18